export var articleDropdownList = [
    {
        id: 1,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/analysis/latest-articles"),
        text: "Latest Articles"
    },
    {
        id: 2,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/commentaries"),
        text: "Commentaries"
    },
    {
        id: 3,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/deals"),
        text: "Deals"
    },
    {
        id: 4,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/distillery"),
        text: "Distillery"
    },
    {
        id: 5,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/emerging-companies"),
        text: "Emerging Companies"
    },
    {
        id: 6,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/finance"),
        text: "Finance"
    },
    {
        id: 7,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/politics-policy-law"),
        text: "Politics, Policy & Law"
    },
    {
        id: 8,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/product-development"),
        text: "Product Development"
    },
    {
        id: 9,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/regulation"),
        text: "Regulation"
    },
    {
        id: 10,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/targets-mechanisms"),
        text: "Targets & Mechanisms"
    },
    {
        id: 11,
        href: "".concat(process.env.NEXT_PUBLIC_BIOCENTURY_URL, "/tools-techniques"),
        text: "Tools & Techniques"
    }, 
];
export var loggedOutBciqDropdownList = [
    {
        id: 1,
        href: "/companies",
        text: "Company Profiles"
    },
    {
        id: 2,
        href: "/targets",
        text: "Target Profiles"
    },
    {
        id: 3,
        href: "/products",
        text: "Product Profiles"
    }, 
];
export var loggedInBciqDropdownList = [
    {
        id: 1,
        href: "".concat(process.env.NEXT_PUBLIC_BCIQ_URL, "/company"),
        text: "Companies"
    },
    {
        id: 2,
        href: "".concat(process.env.NEXT_PUBLIC_BCIQ_URL, "/pipeline"),
        text: "Products"
    },
    {
        id: 3,
        href: "".concat(process.env.NEXT_PUBLIC_BCIQ_URL, "/finance"),
        text: "Finance"
    },
    {
        id: 4,
        href: "".concat(process.env.NEXT_PUBLIC_BCIQ_URL, "/deal"),
        text: "Deals"
    }, 
];
export var conferenceDropdownList = [
    {
        id: 1,
        href: "".concat(process.env.NEXT_PUBLIC_CONFERENCES_URL, "/china-healthcare-summit"),
        text: "China Healthcare Summit"
    },
    {
        id: 2,
        href: "".concat(process.env.NEXT_PUBLIC_CONFERENCES_URL, "/bioequity-europe"),
        text: "Bio\u20ACquity Europe"
    }, 
];
